import { useEffect, useRef } from 'react';
import { describeCombatEvent } from '../utils/rollLogFormat';
import { SPELL_DAMAGE_LOG_EVENT } from './useSpellDamageFeedback';

/**
 * Sends what the server rolled for reactions and delayed effects to the roll log, once each. Whatever is already in the
 * combat state when this first sees it stays out, so a refresh doesn't repeat old rolls.
 */
export default function useCombatEventRollLog({ campaignId, characterId, eventLog }) {
  const seen = useRef(null);
  useEffect(() => {
    if (!campaignId || !Array.isArray(eventLog)) return;
    if (!seen.current) { seen.current = new Set(eventLog.map(event => event?.id)); return; }
    for (const event of eventLog) {
      if (!event?.id || seen.current.has(event.id)) continue;
      seen.current.add(event.id);
      const entry = describeCombatEvent(event);
      if (entry) window.dispatchEvent(new CustomEvent(SPELL_DAMAGE_LOG_EVENT, { detail: { campaignId, sourceCombatantId: characterId, id: event.id, label: entry.label, logLines: entry.lines } }));
    }
  }, [campaignId, characterId, eventLog]);
}
